import React, { useEffect, useState } from "react";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import CheckAndReturn from "../../utility/CheckAndReturn";
import { useSelector } from "react-redux";
import configServ from "../../services/config";
import TeacherCard from "./TeacherCard";
import { toast } from "react-hot-toast";
import TeacherTable from "./TeacherTable";
import Swal from "sweetalert2";
const TeacherBatchPage = () => {
  //#region
  const [openDialog, setOpenDialog] = useState(false);
  const [batches, setBatches] = useState([]);

  const [editData, setEditData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [backDropLoader, setBackDropLoader] = useState(false);
  const [teacherList, setTeacherList] = useState([]);
  const [batchTeacherList, setBatchTeacherList] = useState([]);

  const { company_id, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const handleClickOpen = () => {
    setOpenDialog(!openDialog);
    setEditData(null);
    setIsEdit(false);
  };
  const handleClose = () => {
    setEditData(null);
    setOpenDialog(false);
    setIsEdit(false);
  };
  const canCreateAttendance = CheckAndReturn.PermissionHandler(
    "create-attendance",
    permissions
  );

  const fetchTeacher = async () => {
    try {
      setBackDropLoader(true);
      const res = await configServ.getAllUsers(company_id);

      if (res?.status) {
        setTeacherList(res.data);
      } else {
        setTeacherList([]);
      }
    } catch (err) {
      console.error("Fetch meeting error:", err);
      setTeacherList([]);
    } finally {
      setBackDropLoader(false);
    }
  };

  useEffect(() => {
    if (openDialog) {
      fetchTeacher();
      fetchbatches();
    }
  }, [openDialog]);

  // Fetch active batches
  const fetchbatches = async () => {
    try {
      setBackDropLoader(true);
      const result = await configServ.getActiveBatches({ company_id });

      if (result?.status === true) {
        setBatches(result.data);
      } else {
        setBatches([]);
      }
    } catch (error) {
      console.error("Error fetching batches:", error);
      setBatches([]);
    } finally {
      setBackDropLoader(false);
    }
  };

  const handleTeacherFormSubmit = async (formData) => {
    try {
      setBackDropLoader(true);
      const payload = {
        ...formData,
        company_id: company_id, // add company id
      };

      let result;

      if (isEdit) {
        // 🔥 UPDATE API
        result = await configServ.updateAssignTeacherBatches(payload);
      } else {
        // 🔥 ADD API
        result = await configServ.assignTeacherBatches(payload);
      }

      // ✔ Success
      if (result?.status === true) {
        toast.success(
          result?.message ||
            (isEdit ? "Updated successfully" : "Added successfully")
        );

        handleClose();
        setIsEdit(false);
        setEditData(null);

        // optional: refresh table
        fetchTeacherBatches();
      }

      // ❌ Error
      else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Server error occurred");
    }finally{
        setBackDropLoader(false)
    }
  };

  const fetchTeacherBatches = async () => {
    try {
      setLoading(true);
      const result = await configServ.getAssignedTeacherBatches(company_id);

      if (result?.status === true) {
        setBatchTeacherList(result.data);
      } else {
        setBatchTeacherList([]);
      }
    } catch (error) {
      console.error("Error fetching batches:", error);
      setBatchTeacherList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeacherBatches();
  }, []);

  const handleEdit = (param) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setOpenDialog(true);
    setEditData(param);
    setIsEdit(true);
  };

  const handleDelete = async (row) => {
    try {
      // 🔹 SweetAlert2 confirmation
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete all batches assigned to this teacher?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        // 🔹 API payload
        const payload = {
          teacher_id: row.teacher_id,
          company_id: company_id, // aapka company_id
        };
        setBackDropLoader(true);

        // 🔹 Call Delete API
        const res = await configServ.deleteAssignedTeacherBatches(payload);

        // 🔹 Success
        if (res?.status) {
          toast.success(res.message);
          fetchTeacherBatches(); // reload table after delete
        }
        // 🔹 Error
        else {
          toast.error(res?.message || "Something went wrong!");
        }
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Server error occurred");
    } finally {
      setBackDropLoader(false);
    }
  };

  //#endregion
  return (
    <>
      <LoaderBackdrop open={backDropLoader} />
      <CardHeadMenu
        title={"Assing Batch To Instructor"}
        handlePopup={canCreateAttendance ? handleClickOpen : undefined}
        create={openDialog}
        disabled={!canCreateAttendance} // ✅ if CardHeadMenu supports disabled prop
      />
      {openDialog && (
        <TeacherCard
          handleClose={handleClose}
          //   fetchTable={fetchMeetings}
          editData={editData}
          setEditData={setEditData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          teacherList={teacherList}
          batches={batches}
          onSubmit={handleTeacherFormSubmit}
        />
      )}
      <TeacherTable
        data={batchTeacherList}
        loading={loading}
        onEdit={(row) => handleEdit(row)}
        onDelete={(row) => handleDelete(row)}
      />
    </>
  );
};

export default TeacherBatchPage;
